import { GroupKey } from "@common/data-models/search-results/group-key";
import { GroupValueConvertor } from "@common/data-models/search-results/result-group";
import { Record } from "@common/data-models/records/record";
import { AssignmentRecord } from "@playbook/data-models/records/assignment-record";

export class AssignmentGroupValueHelpers {
    public static TopicMetadata(): GroupValueConvertor {
        return (rec: Record) => {
            let assignment = <AssignmentRecord>rec;
            return [new GroupKey(
                assignment.topicMetadata.guid,
                assignment.topicMetadata.slug ? assignment.topicMetadata.slug : "Missing slug",
                assignment.topicMetadata
            )];
        };
    }
}
